import { UNDERLYING_ASSETS } from '../model/consts/underlying-asset-type.const';
import { UnderlyingAsset } from './../model/interfaces/underlying-asset.interface';

export function FormatUnderlyingAssetLabel(
  underlyingAsset: UnderlyingAsset
): string {
  const typeLabel = UNDERLYING_ASSETS.find(
    (asset) => asset.id === underlyingAsset.type
  );
  const label: string =
    underlyingAsset.assetId +
    ' | ' +
    underlyingAsset.longName +
    '<br>' +
    (underlyingAsset.exchange?.trim().length
      ? underlyingAsset.exchange + ' | '
      : '') +
    (typeLabel?.displayValue ? typeLabel.displayValue + ' | ' : '') +
    (underlyingAsset.currency ? underlyingAsset.currency + ' ' : '');

  return label;
}
